var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    `${_vm.carbonPrefix}--side-nav__header-navigation`,
    { [`${_vm.carbonPrefix}--side-nav__header-divider`]: _vm.divider },
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }